<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-header" style="padding: 10px">
                <!--  -->
                <b-form @submit.prevent="onSubmit">
                    <b-row>
                        <b-col xs="3" sm="3" md="4" lg="4" xl="4">
                            <label>Identificativo</label>
                            <b-form-input v-model="filtro.identificativoAppuntamento" type="search" placeholder="Identificativo"></b-form-input>
                        </b-col>
                        <b-col xs="3" sm="3" md="4" lg="4" xl="4">
                            <label>Cognome</label>
                            <b-form-input v-model="filtro.cognome" type="search" placeholder="Cognome"></b-form-input>
                        </b-col>
                        <b-col xs="3" sm="3" md="4" lg="4" xl="4">
                            <label>Nome</label>
                            <b-form-input v-model="filtro.nome" type="search" placeholder="Nome"></b-form-input>
                        </b-col>
                        <b-col xs="3" sm="3" md="3" lg="3" xl="3">
                            <label>Data Dal</label>
                            <date-picker v-model="filtro.dataDal" format="DD-MM-YYYY" value-type="timestamp" type="date"></date-picker>
                        </b-col>
                        <b-col xs="3" sm="3" md="3" lg="3" xl="3">
                            <label>Data Al</label>
                            <date-picker v-model="filtro.dataAl" format="DD-MM-YYYY" value-type="timestamp" type="date"></date-picker>
                        </b-col>

                        <b-col xs="3" sm="3" md="3" lg="3" xl="3">
                            <label>Agenda</label>
                            <b-form-select v-model="filtro.idAgenda" class="mb-2 mr-sm-2 mb-sm-0" :options="agendaItemsOptions" :value="null" text-field="descrizione" value-field="id">
                                <template #first>
                                    <b-form-select-option :value="null">- TUTTE -</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                        <b-col xs="3" sm="3" md="3" lg="3" xl="3">
                            <label>BOX</label>
                            <b-form-select v-model="filtro.idBox" class="mb-2 mr-sm-2 mb-sm-0" :options="boxItemsOptions" :value="null" text-field="nome" value-field="id">
                                <template #first>
                                    <b-form-select-option :value="null">- TUTTI -</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="sa-padding-right text-right">
                            <b-button @click="onClickResetFilter" variant="danger">Reset</b-button>
                            <b-button type="submit" variant="info">Cerca</b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </div>
            <div class="sa-flexbox-body">
                <div class="d-flex flex-column">
                    <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                        <b-col lg="3">
                            <p>Records Totali: {{ rows }}</p>
                        </b-col>
                        <b-col lg="9">
                            <b-pagination :total-rows="rows" v-model="currentPage" :per-page="perPage" align="right" size="sm"> </b-pagination>
                        </b-col>
                    </b-row>
                </div>

                <div class="sa-test" style="height: 100%">
                    <b-row class="sa-card-list">
                        <b-col v-for="item of items" :key="item.id" class="sa-card-list-col" cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <div class="sa-card-list-container">
                                <div class="sa-card-list-container-body">
                                    <img src="@/assets/images/ico_m.png" />
                                    <div>
                                        <!-- <img v-if="item.sesso === 'M'" src="@/assets/images/ico_m.png" />
                                                <img v-else src="@/assets/images/ico_f.png" /> -->
                                    </div>
                                    <div style="flex: 1; padding-left: 5px">
                                        <span class="sa-card-list-container-body-row"
                                            >Box:<b>{{ item.nomeBox }}</b></span
                                        >
                                        <span class="sa-card-list-container-body-row"
                                            ><b>{{ item.cognome + " " + item.nome }}</b></span
                                        >
                                        <span class="sa-card-list-container-body-row">
                                            Data Ora Prenotazione: <b>{{ formatDateTime(item.dataOra) }}</b></span
                                        >
                                        <span class="sa-card-list-container-body-row">
                                            <b>{{ item.identificativo }}</b></span
                                        >
                                    </div>
                                </div>
                                <div class="sa-card-list-container-footer text-right">
                                    <b-button v-b-tooltip.hover size="sm" variant="outline-success outline-secondary-noborder pull-right" title="Cartella Paziente" @click="onClickPresaInCarico(item)" class="mr-1 no-text">
                                        <b-icon icon="book" variant="outline-sucess"></b-icon>
                                    </b-button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>

                <external-prenotazioni-paziente-modal-component ref="mdlExternalPrenotazioniPaziente" />
                <!-- <identity-manager-modal-edit-component ref="cmpIdentityManagerModalEdit" @deleteIdentity="loadDataIdentityManager" @onSave="loadDataIdentityManager" /> -->
            </div>
            <div class="d-flex flex-column">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Records Totali: {{ rows }}</p>
                    </b-col>

                    <b-col lg="9">
                        <b-pagination :total-rows="rows" v-model="currentPage" :per-page="perPage" align="right" size="sm"> </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import ExternalPrenotazioniPazienteModalComponent from "./ExternalPrenotazioniPazienteModalComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import BoxMixins from "../../agende/agendabox/mixins/BoxMixins";
import AgendaMixin from "../../agende/agenda/mixins/AgendaMixin";
export default {
    components: { ExternalPrenotazioniPazienteModalComponent, DatePicker },
    mixins: [BoxMixins, UtilityMixin, AgendaMixin],
    data() {
        return {
            perPage: 10,
            currentPage: 1,
            filter: null,
            id: "-1",
            items: [],
            idAmbulatorio: "",
            prenotazione: {},
            pathResourcePazienti: "/pazienti",
            pathResource: "/agendeboxaccettazione",
            pathResourceDettaglioUtentiCrm: "/externalprenotazioni",
            paziente: { id: null },
            filtro: {
                idAmbulatorio: null,
                idAgenda: null,
                idBox: null,
                dataDal: new Date().getTime(),
                dataAl: null,
                identificativoAppuntamento: "",
                nome: "",
                cognome: "",
            },
        };
    },
    methods: {
        init() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.idAmbulatorio = sessionStorage.getItem("idAmbulatorio");
            me.filtro.idAmbulatorio = me.idAmbulatorio;
            this.loadData();
            this.loadDataDefault();
        },
        onSubmit() {
            this.loadData();
        },
        loadData() {
            let me = this;
            me.filtro.forPage = me.perPage;
            me.filtro.page = me.currentPage;

            this.loadDataResources(this.pathResource, this.filtro, this.loadDataSuccess, null);
        },
        loadDataSuccess(response) {
            this.items = response.data.data.list;
        },
        loadDataDefault() {
            this.loadDataAgende();
            this.loadDataBox();
        },
        loadDataAgende() {
            this.agendeLoadData();
        },
        loadDataBox() {
            this.boxLoadData();
        },
        onClickResetFilter() {
            this.filtro = {
                idAmbulatorio: this.idAmbulatorio,
                idAgenda: null,
                idBox: null,
                identificativoAppuntamento: "",
                nome: "",
                cognome: "",
            };
            this.loadData();
        },
        onClickPresaInCarico(item) {
            let me = this;
            // console.log(item);
            me.prenotazione = item;
            me.checkPresentAnagrafica();
        },
        checkPresentAnagrafica() {
            let me = this;
            let path = process.env.VUE_APP_PATH_API + me.pathResourcePazienti + "/identificativo/" + me.prenotazione.identificativo.trim();
            UtilityMixin.methods.restCallGet(path, null, me.checkPresentAnagraficaSuccess, me.checkPresentAnagraficaError);
        },
        checkPresentAnagraficaSuccess(response) {
            let me = this;
            me.paziente = response.data.data;
            me.$emit("afterLoadData");
            me.$refs.mdlExternalPrenotazioniPaziente.init(me.paziente, me.prenotazione);
        },
        checkPresentAnagraficaError(error) {
            let me = this;
            me.$emit("afterLoadData", error);
            // console.log("PD");
            let path = process.env.VUE_APP_PATH_API + me.pathResourceDettaglioUtentiCrm + "/contatto/" + me.prenotazione.idAppuntamento;
            UtilityMixin.methods.restCallGet(path, null, me.loadDatiPazienteSuccess, me.loadDatiPazienteError);
        },
        loadDatiPazienteSuccess(response) {
            let me = this;
            let crmPrenotazione = response.data.data;
            me.paziente.id = null;
            me.paziente.identificativo = crmPrenotazione.codiceFiscale;
            me.paziente.cognome = crmPrenotazione.lastName;
            me.paziente.nome = crmPrenotazione.firstName;
            me.paziente.indirizzoResidenza = crmPrenotazione.address1;
            me.paziente.indirizzoDomicilio = crmPrenotazione.address1;
            me.paziente.note = "";
            me.paziente.regioneNascita = null;
            me.paziente.regioneResidenza = null;
            me.paziente.regioneDomicilio = null;
            me.paziente.sesso = null;
            me.paziente.comuneDomicilioCodiceIstat = crmPrenotazione.city;
            me.paziente.provinciaDomicilio = crmPrenotazione.country;
            me.paziente.comuneNascitaCodiceIstat = null;
            me.paziente.provinciaNascita = null;
            me.paziente.comuneResidenzaCodiceIstat = crmPrenotazione.city;
            me.paziente.provinciaResidenza = crmPrenotazione.country;
            me.paziente.capResidenza = crmPrenotazione.postalCode;
            me.paziente.capDomicilio = crmPrenotazione.postalCode;
            me.paziente.telefono = crmPrenotazione.phone;
            me.paziente.email = crmPrenotazione.email;
            me.paziente.gruppoSanguigno = "patient.blood.lblUndefined";
            me.$refs.mdlExternalPrenotazioniPaziente.init(me.paziente, me.prenotazione);
        },
        loadDatiPazienteError(error) {
            let me = this;
            me.$emit("afterLoadData", error);
            me.paziente.id = null;
            me.paziente.identificativo = me.prenotazione.identificativo;
            me.paziente.cognome = me.prenotazione.cognome;
            me.paziente.nome = me.prenotazione.nome;
            me.paziente.indirizzoResidenza = "";
            me.paziente.indirizzoDomicilio = "";
            me.paziente.note = "";
            me.paziente.regioneNascita = null;
            me.paziente.regioneResidenza = null;
            me.paziente.regioneDomicilio = null;
            me.paziente.sesso = null;
            me.paziente.comuneDomicilioCodiceIstat = null;
            me.paziente.provinciaDomicilio = null;
            me.paziente.comuneNascitaCodiceIstat = null;
            me.paziente.provinciaNascita = null;
            me.paziente.comuneResidenzaCodiceIstat = null;
            me.paziente.provinciaResidenza = null;
            me.paziente.capResidenza = null;
            me.paziente.capDomicilio = null;
            me.paziente.gruppoSanguigno = null;
            me.paziente.telefono = "";
            me.paziente.email = "";
            me.paziente.gruppoSanguigno = "patient.blood.lblUndefined";
            me.$refs.mdlExternalPrenotazioniPaziente.init(me.paziente, me.prenotazione);
        },
    },
    mounted() {
        this.loadDataDefault();
    },
    computed: {
        rows() {
            return this.items.length;
        },
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
};
</script>

<style lang="scss" scoped>
.sa-card-list {
    padding: 2rem;
    margin-bottom: 100px;
}
</style>
